var PageView = Backbone.View.extend({
  updatePromotions: function(promotions) {
    var containers = this.$("[data-load-promotions]");

    _.each(containers, function(el) {
      var promo = promotions.get({
        id: $(el).data("sailing")
      });

      if (promo && promo.get("count")) {
        var compareData = new Backbone.Model(
          $(el)
            .find("[data-compare-tray-model]")
            .data("compare-tray-model")
        );
        var addClass = "";

        compareData.set("promotions", promo.get("count"));

        if (promo.get("count") > 1) {
          addClass = "multiple";
        } else if (promo.get("count") == 1) {
          addClass = "single";
        }

        compareData.set("promotion_class", addClass);

        $(el)
          .addClass("has-promotions")
          .find("[data-promotions]")
          .attr("data-tab-trigger", "promotions")
          .removeClass("is-hidden is-disabled")
          .end()
          .find("[data-promotions-icon]")
          .addClass(addClass)
          .end()
          .find("[data-promotions-count]")
          .html(promo.get("count"))
          .end()
          .find("[data-compare-tray-model]")
          .attr("data-compare-tray-model", JSON.stringify(compareData))
          .end();

        if (promo.get("count") > 0) {
          $(el)
            .next()
            .find("[data-details]")
            .removeClass("no-promotions")
            .end();
        }
      }
    });

    this.promotionsLoaded = true;
  },

  updatePromotionLogos: function(logos) {
    var containers = this.$("[data-load-promotion-logos]");

    _.each(containers, function(el) {
      var promo = logos.get({
        id: $(el).data("sailing")
      });

      if (promo && promo.get("logo_path")) {
        $(el)
          .attr("title", promo.get("level_name"))
          .find("[data-promotions-icon]")
          .removeClass("multiple single")
          .addClass("has-image")
          .css({
            "background-image":
              "url(" + REVELEX.settings.linkRoot + promo.get("logo_path") + ")"
          })
          .end();
      }
    });

    this.promotionLogosLoaded = true;
  },

  updatePromotionTags: function(tags, template) {
    var containers = this.$("[data-load-promotion-tags]");

    _.each(containers, function(el) {
      const sailingId = String($(el).data("sailing"));

      var tagData = new Backbone.Collection(
        tags.filter(tag => String(tag.get("sailing_id")) === sailingId)
      );

      if (tagData.length) {
        $(el)
          .find("[data-promotions-tags]")
          .html(template({ tags: tagData.toJSON() }))
          .removeClass("is-hidden");
      }
    });

    this.promotionTagsLoaded = true;
  },

  toggleCompareItems: function(compareItems) {
    var self = this;

    self.$("[data-compare-tray-item]").removeAttr("checked");

    _.each(compareItems.toArray(), function(item) {
      self
        .$('[data-compare-tray-item="' + item.get("id") + '"]')
        .attr("checked", true);
    });
  },

  initialize: function() {
    this.promotionsLoaded = this.$el.data("promotionsLoaded") ? true : false;
    this.promotionLogosLoaded = this.$el.data("promotionLogosLoaded")
      ? true
      : false;
    this.promotionTagsLoaded = this.$el.data("promotionTagsLoaded")
      ? true
      : false;
  }
});

module.exports = PageView;
